export default [
    {
        name: "email",
        label: "Email",
        type: "string",
    },
    {
        name: "roleIds",
        label: "Roles",
        type: "list",
        helpText: "Roles",
        url: "/roles",
        filterValue: "name",
        entityName: "roles",
        formatLabels: true,
        include: false,
    },
    {
        name: "createdAt",
        label: "Joined At",
        type: "date",
    },
    {
        name: "updatedAt",
        label: "Updated At",
        type: "date",
    },

    {
        name: "assigneeType",
        label: "Assignment Type",
        type: "string",
    },
    {
        name: "branches",
        label: "branches",
        type: "list",
    },
];
